module.exports = new __parcel__URL__("recruitment_zh-cn.e2e14b57.webp").toString();